import { motion } from "framer-motion";

const Apply = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed bottom-5 right-5 z-50"
    >
      <a
        href="https://pmn.vercel.app/artisans/inscription"
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-[#069861] text-white px-6 py-3 rounded-full text-base font-medium shadow-lg hover:bg-[#21e89b] hover:scale-105 transition-all duration-300"
      >
        Inscription
      </a>
    </motion.div>
  );
};

export default Apply; 